import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Edit, Trash2, Plus, X, FileText } from 'lucide-react';

const IndividualDetailView = ({ detail, onEdit, onDelete, onAddTriple, onDeleteTriple }) => {
  const triples = detail.triples || [];
  const linkedNotes = detail.linked_notes || [];
  const classColor = detail.class_color || '#002FA7';
  return (
    <div className="space-y-3" data-testid={`individual-detail-${detail.individual_id}`}>
      <div className="flex items-start justify-between">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <span className="w-3 h-3 rounded-full" style={{ backgroundColor: classColor }} />
            <h3 className="text-base font-semibold text-[#111827]">{detail.name}</h3>
            <Badge className="text-[10px]" style={{ backgroundColor: classColor + '20', color: classColor }}>{detail.class_name}</Badge>
          </div>
          <p className="text-[10px] text-[#9CA3AF] mt-1 font-mono">{detail.iri}</p>
          {detail.description && <p className="text-xs text-[#4B5563] mt-2">{detail.description}</p>}
        </div>
        <div className="flex gap-1">
          <Button size="sm" variant="outline" className="h-7 text-xs" onClick={onEdit}><Edit className="w-3.5 h-3.5 mr-1" />Edit</Button>
          <Button size="sm" variant="ghost" className="h-7 w-7 p-0 text-[#FF3B30]" onClick={onDelete}><Trash2 className="w-3.5 h-3.5" /></Button>
        </div>
      </div>
      <div>
        <div className="flex items-center justify-between mb-1.5">
          <h4 className="text-xs font-semibold">Triples ({triples.length})</h4>
          <Button size="sm" variant="ghost" className="h-6 text-xs" onClick={onAddTriple} data-testid="add-triple-btn"><Plus className="w-3 h-3 mr-1" />Add assertion</Button>
        </div>
        {triples.length === 0 && <p className="text-[10px] text-[#9CA3AF]">No assertions yet.</p>}
        {triples.length > 0 && (
          <div className="space-y-1">
            {triples.map(t => (
              <div key={t.triple_id} className="flex items-center gap-2 p-2 rounded border border-[#E5E7EB] text-xs group" data-testid={`triple-${t.triple_id}`}>
                <span className="font-medium text-[#111827]">{detail.name}</span>
                <Badge variant="secondary" className="text-[9px]">{t.relation_name}</Badge>
                <span className="text-[#4B5563]">{t.counterpart_name}</span>
                <Button size="sm" variant="ghost" className="h-5 w-5 p-0 ml-auto text-[#FF3B30]" onClick={() => onDeleteTriple(t.triple_id)}><X className="w-3 h-3" /></Button>
              </div>
            ))}
          </div>
        )}
      </div>
      {linkedNotes.length > 0 && (
        <div>
          <h4 className="text-xs font-semibold mb-1.5 flex items-center gap-1"><FileText className="w-3 h-3" />Linked PKM Notes</h4>
          <div className="space-y-1">
            {linkedNotes.map(n => (
              <a key={n.note_id} href={`/pkm?note_id=${n.note_id}`} className="block p-1.5 rounded border border-[#E5E7EB] text-xs hover:bg-[#F9FAFB]">
                <span className="font-medium">{n.title}</span>
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default IndividualDetailView;
